import {Grid, Paper} from "@mui/material";
import React from "react";
import MainMenu from "../../../components/MainMenu";
import TeamRankingList from "../../../components/TeamRankingComponent/TeamRankingList";

const index = () => {
    return (
        <MainMenu>
            <Grid container>
                <Grid item xs={12}>
                    <Paper elevation={3}>
                        <TeamRankingList/>
                    </Paper>
                </Grid>
            </Grid>
        </MainMenu>
    );
};

export default index;
